import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';

import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import InputDate from './InputDate';
import consts from '../libs/consts';

import Radios from './Radios';
import Checkbox from './Checkbox';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import DaumPostcode from 'react-daum-postcode';
import { getBase64, getBase64toDataUrl, getMemberinfo, numFormat, heckName } from '../utils/utils';
import InfoViewlists from './InfoViewlists';
import * as APIS from "../utils/service";
import DatePicker from "react-datepicker";

export default function ContractwriterPage2(props) {

    const {
        row={},
        setviewpages=()=>{},
        scrolTopFunc=()=>{},
        contractWirteSubmit=()=>{},
        memberinfos={}
    } = props;
    
    const { configdata } = useSelector(s => s.configReducer);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [sell_type, setsell_type] = useState('매매');   
    const [category, setcategory] = useState('집합건물');

    const [errmsg, seterrmsg] = useState('');   
    const [contract, setcontract] = useState(JSON?.parse(row?.contract)); 

    let yearDatas = [];
    let monthDatas = [];
    let dayDatas = [];
    //{labels: '선택하세요', values: ''}
    let starty = moment().add(-5, 'Y').format('YYYY');
    let endy = moment().add(+5, 'Y').format('YYYY');
    for(let y = starty; y <= endy; y++){
        yearDatas.push({labels: y+'', values: y+''});
    }
    for(let m = 1; m <= 31; m++){
        let monthtxt = m < 10 ? '0'+m : m;
        monthDatas.push({labels: monthtxt+'', values: monthtxt+''});
    }
    for(let d = 1; d <= 31; d++){
        let daytxt = d < 10 ? '0'+d : d;
        dayDatas.push({labels: daytxt+'', values: daytxt+''});
    }

    const [isOpenPost, setIsOpenPost] = useState(false);
    const [addrDatas, setaddrDatas] = useState({});
    const [price_all, setprice_all] = useState(0);
    const [checkvalues, setcheckvalues] = useState([]);   
    const [checkvalues2, setcheckvalues2] = useState([]);   

    const [etcText1, setetcText1] = useState('');   //확인·설명근거자료 등 그밖
    const [etcText2, setetcText2] = useState('');   //권리관계 민간 임대 등록 여부 등록 그밖의유형
    const [etcText3, setetcText3] = useState('');   //입지조건 주차장 그밖
    const [etcText4, setetcText4] = useState('');   //비선호시설(1km이내) 그밖
    const [etcText5, setetcText5] = useState('');   //내부외부시설물의상태-수도-파손여부 위치
    const [etcText6, setetcText6] = useState('');   //내부외부시설물의상태-수도-용수량 위치
    const [etcText7, setetcText7] = useState('');   //내부외부시설물의상태-전기-공급상태 교체할 부분
    const [etcText8, setetcText8] = useState('');   //내부외부시설물의상태-가스-공급방식 그밖의방식
    const [etcText9, setetcText9] = useState('');   //내부외부시설물의상태-소방-단독경보형감지기 수량
    const [etcText10, setetcText10] = useState('');   //내부외부시설물의상태-난방방식및연료공급-시설작동 수선필요
    const [etcText11, setetcText11] = useState('');   //※개별공급인경우사용연한
    const [etcText12, setetcText12] = useState('');   //내부외부시설물의상태-난방방식및연료공급-종류 그밖의종류
    const [etcText13, setetcText13] = useState('');   //내부외부시설물의상태-배수 수선필요
    const [etcText14, setetcText14] = useState('');   //내부외부시설물의상태-배수-균열 위치
    const [etcText15, setetcText15] = useState('');   //내부외부시설물의상태-배수-누수 위치
    const [etcText16, setetcText16] = useState('');   //벽면바닥면및도배상태-바닥면 수리 필요
    const [etcText17, setetcText17] = useState('');   //환경조건-일조량 이유
    const [etcText18, setetcText18] = useState('');   //관리비포함비목-그밖의비목
    const [etcText19, setetcText19] = useState('');   //관리에관한사항-관리비-관리비부과방식


    const [inputArr, setinputArr] = useState([
        {keys: "건축물선택", values: '', requireCkr: false, errmsg: '건축물선택사항을 선택해주세요.'},
        {keys: "설명근거자료", values: '', requireCkr: false, errmsg: '확인·설명근거자료를 선택해주세요.'},
        {keys: "대상물건요구사항", values: '', requireCkr: false, errmsg: '확인·설명근거자료를 선택해주세요.'},
        {keys: "대상물건의표시-토지-소재지", values: '', requireCkr: false, errmsg: '대상물건의표시-토지-소재지를 입력해주세요.'},
        {keys: "대상물건의표시-토지-면적", values: '', requireCkr: false, errmsg: '대상물건의표시-토지-면적를 입력해주세요.'},
        {keys: "대상물건의표시-토지-지목-공부상지목", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-지목-공부상지목')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-지목-실제이용상태", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-지목-실제이용상태')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-전용면적", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-전용면적')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-대지지분", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-대지지분')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-준공년도", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-준공년도')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-건축물대장상용도", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-건축물대장상용도')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-실제용도", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-실제용도')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-구조", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-구조')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-방향", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-방향')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-기준", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-기준')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-내진설계적용여부", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-내진설계적용여부')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-내진능력", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-내진능력')+' 입력해주세요.'},
        {keys: "대상물건의표시-토지-건축물-위반건축물여부", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-위반건축물여부')+' 선택해주세요.'},
        {keys: "대상물건의표시-토지-건축물-위반내용", values: '', requireCkr: false, errmsg: heckName('대상물건의표시-토지-건축물-위반내용')+' 입력해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권에관한사항-토지", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-토지')+' 입력해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권외의권리사항-토지", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권외의권리사항-토지')+' 입력해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권에관한사항-건축물", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-건축물')+' 입력해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권외의권리사항-건축물", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권외의권리사항-건축물')+' 입력해주세요.'},
        {keys: "권리관계-민간임대등록여부-등록-선택사항", values: '', requireCkr: false, errmsg: heckName('권리관계-민간임대등록여부-등록-선택사항')+' 선택해주세요.'},
        {keys: "권리관계-민간임대등록여부-등록-임대의무기간", values: '', requireCkr: false, errmsg: heckName('권리관계-민간임대등록여부-등록-임대의무기간')+' 입력해주세요.'},
        {keys: "권리관계-민간임대등록여부-등록-임대개시일", values: '', requireCkr: false, errmsg: heckName('권리관계-민간임대등록여부-등록-임대개시일')+' 입력해주세요.'},
        {keys: "권리관계-민간임대등록여부-미등록", values: '', requireCkr: false, errmsg: heckName('권리관계-민간임대등록여부-미등록')+' 선택해주세요.'},
        {keys: "권리관계-계약갱신요구권행사여부", values: '', requireCkr: false, errmsg: heckName('권리관계-계약갱신요구권행사여부')+' 선택해주세요.'},
        {keys: "권리관계-다가구주택확인서류제출여부", values: '', requireCkr: false, errmsg: heckName('권리관계-다가구주택확인서류제출여부')+' 선택해주세요.'},
        {keys: "권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가", values: [], requireCkr: false, errmsg: '특약사항을 입력해주세요.'},

        {keys: "토지이용계획-지역지구-용도지역", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-용도지역')+' 입력해주세요.'},
        {keys: "토지이용계획-지역지구-용도지구", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-용도지구')+' 입력해주세요.'},
        {keys: "토지이용계획-지역지구-용도구역", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-용도구역')+' 입력해주세요.'},
        {keys: "토지이용계획-지역지구-건폐율상한", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-건폐율상한')+' 입력해주세요.'},
        {keys: "토지이용계획-지역지구-용적률상한", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지역·지구-용적률상한')+' 입력해주세요.'},
        {keys: "토지이용계획-도시군계획시설", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-도시·군계획 시설')+' 입력해주세요.'},
        {keys: "토지이용계획-허가신고구역여부", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-허가·신고 구역 여부')+' 선택해주세요.'},
        {keys: "토지이용계획-투기지역여부", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-투기지역여부')+' 선택해주세요.'},
        {keys: "토지이용계획-지구단위계획구역", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-지구단위계획구역, 그 밖의 도시·군관리계획')+' 입력해주세요.'},
        {keys: "토지이용계획-그밖의이용제한", values: '', requireCkr: false, errmsg: heckName('토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항-그 밖의 이용제한 및 거래규제사항')+' 입력해주세요.'},
        {keys: "입지조건-도로와의관계1", values: '', requireCkr: false, errmsg: heckName('입지조건-도로와의관계')+' 입력해주세요.'},
        {keys: "입지조건-도로와의관계2", values: '', requireCkr: false, errmsg: heckName('입지조건-도로와의관계')+' 입력해주세요.'},
        {keys: "입지조건-도로와의관계3", values: '', requireCkr: false, errmsg: heckName('입지조건-도로와의관계')+' 선택해주세요.'},
        {keys: "입지조건-도로와의관계-접근성", values: '', requireCkr: false, errmsg: heckName('입지조건-도로와의관계-접근성')+' 선택해주세요.'},
        {keys: "입지조건-대중교통-버스", values: '', requireCkr: false, errmsg: heckName('입지조건-대중교통-버스')+' 입력해주세요.'},
        {keys: "입지조건-대중교통-버스2", values: '', requireCkr: false, errmsg: heckName('입지조건-대중교통-버스')+' 선택해주세요.'},
        {keys: "입지조건-대중교통-버스3", values: '', requireCkr: false, errmsg: heckName('입지조건-대중교통-버스')+' 입력해주세요.'},
        {keys: "입지조건-대중교통-지하철1", values: '', requireCkr: false, errmsg: heckName('입지조건-대중교통-지하철')+' 입력해주세요.'},
        {keys: "입지조건-대중교통-지하철2", values: '', requireCkr: false, errmsg: heckName('입지조건-대중교통-지하철')+' 선택해주세요.'},
        {keys: "입지조건-대중교통-지하철3", values: '', requireCkr: false, errmsg: heckName('입지조건-대중교통-지하철')+' 입력해주세요.'},
        {keys: "입지조건-주차장1", values: '', requireCkr: false, errmsg: heckName('입지조건-주차장')+' 선택해주세요.'},
        {keys: "입지조건-교육시설-초등학교1", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-초등학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-초등학교2", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-초등학교')+' 선택해주세요.'},
        {keys: "입지조건-교육시설-초등학교3", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-초등학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-중학교1", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-중학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-중학교2", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-중학교')+' 선택해주세요.'},
        {keys: "입지조건-교육시설-중학교3", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-중학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-고등학교1", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-고등학교')+' 입력해주세요.'},
        {keys: "입지조건-교육시설-고등학교2", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-고등학교')+' 선택해주세요.'},
        {keys: "입지조건-교육시설-고등학교3", values: '', requireCkr: false, errmsg: heckName('입지조건-교육시설-고등학교')+' 입력해주세요.'},
        {keys: "입지조건-판매및의료시설-백화점및할인매장1", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-백화점 및 할인매장')+' 입력해주세요.'},
        {keys: "입지조건-판매및의료시설-백화점및할인매장2", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-백화점 및 할인매장')+' 선택해주세요.'},
        {keys: "입지조건-판매및의료시설-백화점및할인매장3", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-백화점 및 할인매장')+' 입력해주세요.'},
        {keys: "입지조건-판매및의료시설-종합의료시설1", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-종합의료시설')+' 입력해주세요.'},
        {keys: "입지조건-판매및의료시설-종합의료시설2", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-종합의료시설')+' 선택해주세요.'},
        {keys: "입지조건-판매및의료시설-종합의료시설3", values: '', requireCkr: false, errmsg: heckName('입지조건-판매및의료시설-종합의료시설')+' 입력해주세요.'},
        {keys: "관리에관한사항-경비실", values: '', requireCkr: false, errmsg: heckName('관리에관한사항-경비실')+' 선택해주세요.'},
        {keys: "관리에관한사항-관리주체", values: '', requireCkr: false, errmsg: heckName('관리에관한사항-관리주체')+' 선택해주세요.'},
        {keys: "비선호시설", values: '', requireCkr: false, errmsg: heckName('비선호시설')+' 선택해주세요.'},
        {keys: "거래예정금액", values: '', requireCkr: false, errmsg: heckName('거래예정금액')+' 입력해주세요.'},
        {keys: "개별공시지가", values: '', requireCkr: false, errmsg: heckName('개별공시지가')+' 입력해주세요.'},
        {keys: "건물주택공시가격", values: '', requireCkr: false, errmsg: heckName('건물주택공시가격')+' 입력해주세요.'},
        {keys: "취득세", values: '', requireCkr: false, errmsg: heckName('취득세')+' 입력해주세요.'},
        {keys: "농어촌특별세", values: '', requireCkr: false, errmsg: heckName('농어촌특별세')+' 입력해주세요.'},
        {keys: "지방교육세", values: '', requireCkr: false, errmsg: heckName('지방교육세')+' 입력해주세요.'},
        {keys: "실제권리관계또는공시되지않은물건의권리사항", values: '', requireCkr: false, errmsg: heckName('실제권리관계또는공시되지않은물건의권리사항')+' 입력해주세요.'},
        {keys: "내부외부시설물의상태-수도-파손여부", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-수도-파손여부')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-수도-용수량", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-수도-용수량')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-전기-공급상태", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-전기-공급상태')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-가스-공급방식", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-가스-공급방식')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-소방-단독경보형감지기", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-소방-단독경보형감지기')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-소방-소화전", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-소방-소화전')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-소방-비상벨", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-소방-비상벨')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-난방방식및연료공급-공급방식", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-난방방식및연료공급-공급방식')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-난방방식및연료공급-시설작동", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-난방방식및연료공급-시설작동')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-난방방식및연료공급-종류", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-난방방식및연료공급-종류')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-승강기", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-승강기')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-배수", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-배수')+' 선택해주세요.'},
        {keys: "내부외부시설물의상태-그밖의시설물", values: '', requireCkr: false, errmsg: heckName('내부외부시설물의상태-그밖의시설물')+' 선택해주세요.'},
        {keys: "벽면바닥면및도배상태-벽면-균열", values: '', requireCkr: false, errmsg: heckName('벽면바닥면및도배상태-벽면-균열')+' 선택해주세요.'},
        {keys: "벽면바닥면및도배상태-벽면-누수", values: '', requireCkr: false, errmsg: heckName('벽면바닥면및도배상태-벽면-누수')+' 선택해주세요.'},
        {keys: "벽면바닥면및도배상태-바닥면", values: '', requireCkr: false, errmsg: heckName('벽면바닥면및도배상태-바닥면')+' 선택해주세요.'},
        {keys: "벽면바닥면및도배상태-도배", values: '', requireCkr: false, errmsg: heckName('벽면바닥면및도배상태-도배')+' 선택해주세요.'},
        {keys: "환경조건-일조량", values: '', requireCkr: false, errmsg: heckName('환경조건-일조량')+' 선택해주세요.'},
        {keys: "환경조건-소음", values: '', requireCkr: false, errmsg: heckName('환경조건-소음')+' 선택해주세요.'},
        {keys: "환경조건-진동", values: '', requireCkr: false, errmsg: heckName('환경조건-진동')+' 선택해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-중개보수", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-중개보수')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-작성일반중개보수", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-작성일반중개보수')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-작성일반실비", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-작성일반실비')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-산출내역중개보수", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-산출내역중개보수')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-산출내역실비", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-산출내역실비')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-실비", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-실비')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-계", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-계')+' 입력해주세요.'},
        {keys: "중개보수및실비의금액과산출내역-지급시기", values: '', requireCkr: false, errmsg: heckName('중개보수및실비의금액과산출내역-지급시기')+' 입력해주세요.'},
        {keys: "수령일년", values: moment().format('YYYY'), requireCkr: false, errmsg: heckName('수령일년')+' 선택해주세요.'},
        {keys: "수령일월", values: moment().format('MM'), requireCkr: false, errmsg: heckName('수령일월')+' 선택해주세요.'},
        {keys: "수령일일", values: moment().format('DD'), requireCkr: false, errmsg: heckName('수령일일')+' 선택해주세요.'},
        
        
        {keys: "매도인", values: contract?.find(item => item?.keys === '매도인')?.values?.map((x, i) => {
            let Arrs = {};
            let indexnum = i+1;
            Arrs = {keys: "매도인"+indexnum, values: [
                {keys: "매도인주소", values: x?.values?.find(item => item?.keys === '매도인주소')?.values, requireCkr: false, errmsg: heckName('매도/임대 주소를')+' 입력해주세요.'},
                {keys: "매도인주민번호", values: x?.values?.find(item => item?.keys === '매도인주민번호')?.values, requireCkr: false, errmsg: heckName('매도/임대 생년월일')+' 입력해주세요.'},
                {keys: "매도인전화", values: x?.values?.find(item => item?.keys === '매도인전화')?.values, requireCkr: false, errmsg: heckName('매도/임대 전화번호')+' 입력해주세요.'},
                {keys: "대리인주소", values: x?.values?.find(item => item?.keys === '대리인주소')?.values, requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호", values: x?.values?.find(item => item?.keys === '대리인주민번호')?.values, requireCkr: false, errmsg: ''},
                {keys: "대리인전화", values: x?.values?.find(item => item?.keys === '대리인전화')?.values, requireCkr: false, errmsg: ''},
            ], requireCkr: false, subflag: x?.subflag, errmsg: ''};
            return Arrs;
        }), requireCkr: false, errmsg: '매도인정보를 입력해주세요.'},

        {keys: "매수인", values: contract?.find(item => item?.keys === '매수인')?.values?.map((x, i) => {
            let Arrs = {};
            let indexnum = i+1;
            Arrs ={keys: "매수인"+indexnum, values: [
                {keys: "매수인주소", values: x?.values?.find(item => item?.keys === '매수인주소')?.values, requireCkr: false, errmsg: heckName('매수/매수 주소를')+' 입력해주세요.'},
                {keys: "매수인주민번호", values: x?.values?.find(item => item?.keys === '매수인주민번호')?.values, requireCkr: false, errmsg: heckName('매수/매수 생년월일')+' 입력해주세요.'},
                {keys: "매수인전화", values: x?.values?.find(item => item?.keys === '매수인전화')?.values, requireCkr: false, errmsg: heckName('매수/매수 전화번호')+' 입력해주세요.'},
                {keys: "대리인주소", values: x?.values?.find(item => item?.keys === '대리인주소')?.values, requireCkr: false, errmsg: ''},
                {keys: "대리인주민번호", values: x?.values?.find(item => item?.keys === '대리인주민번호')?.values, requireCkr: false, errmsg: ''},
                {keys: "대리인전화", values: x?.values?.find(item => item?.keys === '대리인전화')?.values, requireCkr: false, errmsg: ''},

            ], requireCkr: false, subflag: x?.subflag, errmsg: ''};
            return Arrs;
        }), requireCkr: false, errmsg: '매수인정보를 입력해주세요.'},

        {keys: "개중등록번호1", values: contract?.find(item => item?.keys === '개중등록번호1')?.values, requireCkr: false, errmsg: heckName('개업공인중개사 등록번호')+' 입력해주세요.'},
        {keys: "개중사무소명칭1", values: contract?.find(item => item?.keys === '개중사무소명칭1')?.values, requireCkr: false, errmsg: heckName('개업공인중개사 사무소명칭')+' 입력해주세요.'},
        {keys: "개중사무소소재지1", values: contract?.find(item => item?.keys === '개중사무소소재지1')?.values, requireCkr: false, errmsg: heckName('개업공인중개사 사무소소재지')+' 입력해주세요.'},
        {keys: "개중소속공인중개사1", values: '', requireCkr: false, errmsg: heckName('개업공인중개사 소속공인중개사')+' 입력해주세요.'},
        {keys: "개중전화번호1", values: contract?.find(item => item?.keys === '개중전화번호1')?.values, requireCkr: false, errmsg: heckName('개업공인중개사 전화번호')+' 입력해주세요.'},

        {keys: "공동중개", values: contract?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => {
            let Arrs = {};
            let indexnum = i+1;
            Arrs ={keys: "공동중개"+indexnum, values: [
                {keys: "공동중개등록번호", values: x?.values?.find(item => item?.keys === '공동중개등록번호')?.values, requireCkr: false, errmsg: heckName('공동 개업공인중개사 등록번호')+' 입력해주세요.'},
                {keys: "공동중개사무소명칭", values: x?.values?.find(item => item?.keys === '공동중개사무소명칭')?.values, requireCkr: false, errmsg: heckName('공동 개업공인중개사 사무소명칭')+' 입력해주세요.'},
                {keys: "공동중개사무소소재지", values: x?.values?.find(item => item?.keys === '공동중개사무소소재지')?.values, requireCkr: false, errmsg: heckName('공동 개업공인중개사 사무소소재지')+' 입력해주세요.'},
                {keys: "공동중개소속공인중개사", values: '', requireCkr: false, errmsg: heckName('공동 개업공인중개사 소속공인중개사')+' 입력해주세요.'},
                {keys: "공동중개전화번호", values: x?.values?.find(item => item?.keys === '공동중개전화번호')?.values, requireCkr: false, errmsg: heckName('공동 개업공인중개사 전화번호')+' 입력해주세요.'},
            ], requireCkr: false, errmsg: ''};
            return Arrs;
        }), requireCkr: false, errmsg: '공동중개정보를 입력해주세요.'},

        {keys: "권리관계-민간임대등록여부-등록-임대보증금보증설명", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        {keys: "권리관계-확정일자부여현황정보-등록-선택사항", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        {keys: "권리관계-확정일자부여현황정보-등록-임차인권리설명", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        {keys: "권리관계-국세및지방세체납정보-등록-선택사항", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        {keys: "권리관계-국세및지방세체납정보-등록-임차인권리설명", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        {keys: "권리관계-전입세대확인서-등록-선택사항", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        {keys: "관리에관한사항-관리비-관리비금액", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        {keys: "관리에관한사항-관리비-관리비포함비목", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        {keys: "관리에관한사항-관리비-관리비부과방식", values: '', requireCkr: false, errmsg: heckName('임대보증금보증설명')+' 선택해주세요.'},
        
    ]);
    
    useEffect(() => {
        console.log(inputArr);
        if(row?.confirmation){
            console.log(row);

            let confirmArr = JSON?.parse(row?.confirmation);
            let inputArrData = confirmArr[0]?.inputs;
            console.log(inputArrData);
            // console.log(inputArrData?.find(item => item?.keys === '공동중개여부')?.values);
            setetcText1(confirmArr[0]?.etcText1);
            setetcText2(confirmArr[0]?.etcText2);
            setetcText3(confirmArr[0]?.etcText3);
            setetcText4(confirmArr[0]?.etcText4);
            setetcText5(confirmArr[0]?.etcText5);
            setetcText6(confirmArr[0]?.etcText6);
            setetcText7(confirmArr[0]?.etcText7);
            setetcText8(confirmArr[0]?.etcText8);
            setetcText9(confirmArr[0]?.etcText9);
            setetcText10(confirmArr[0]?.etcText10);
            setetcText11(confirmArr[0]?.etcText11);
            setetcText12(confirmArr[0]?.etcText12);
            setetcText13(confirmArr[0]?.etcText13);
            setetcText14(confirmArr[0]?.etcText14);
            setetcText15(confirmArr[0]?.etcText15);
            setetcText16(confirmArr[0]?.etcText16);
            setetcText17(confirmArr[0]?.etcText17);
            setetcText18(confirmArr[0]?.etcText18);
            setetcText19(confirmArr[0]?.etcText19);
            if(inputArrData){
                setinputArr(inputArrData);
                if(inputArrData?.find(item => item?.keys === '설명근거자료')?.values){
                    setcheckvalues(inputArrData?.find(item => item?.keys === '설명근거자료')?.values);
                } else {
                    setcheckvalues([]);
                }
                if(inputArrData?.find(item => item?.keys === '권리관계-민간임대등록여부-미등록')?.values){
                    setcheckvalues2(inputArrData?.find(item => item?.keys === '권리관계-민간임대등록여부-미등록')?.values);
                } else {
                    setcheckvalues2([]);
                }
            }
        } else {
            
        }
    }, [row]);
    useEffect(() => {
        seterrmsg('');
    }, [inputArr]);
    useEffect(() => {
        seterrmsg('');
        let inputArrData = inputArr;
        let contractinfo = JSON?.parse(row?.contract);

        if(row?.confirmation){
            let confirmArr = JSON?.parse(row?.confirmation);
            inputArrData = confirmArr[0]?.inputs;
            if(inputArr?.find(item => item?.keys === '건축물선택')?.values !== ''){
                if(inputArrData?.find(item => item?.keys === '건축물선택')?.values !== inputArr?.find(item => item?.keys === '건축물선택')?.values){
                    inputArrData = inputArrData?.map(item => item?.keys === '건축물선택' ? {...item, values: inputArr?.find(item => item?.keys === '건축물선택')?.values} : item);
                }
            }
        } else {
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-용도지역' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-용도지구' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-용도구역' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-건폐율상한' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-용적률상한' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-도시군계획시설' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-허가신고구역여부' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-투기지역여부' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지구단위계획구역' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-그밖의이용제한' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '개별공시지가' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '건물주택공시가격' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '취득세' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '농어촌특별세' ? {...item, requireCkr: false, values: ''} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '지방교육세' ? {...item, requireCkr: false, values: ''} : item);


            inputArrData = inputArrData?.map(item => item?.keys === '대상물건의표시-토지-소재지' ? {...item, values: contractinfo?.find(item => item?.keys === '소재지')?.values } : item);

            // inputArrData = inputArrData?.map(item => item?.keys === '매도인주소' ? {...item, values: contractinfo?.find(item => item?.keys === '매도인주소')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '매도인주민번호' ? {...item, values: contractinfo?.find(item => item?.keys === '매도인주민번호')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '매도인전화' ? {...item, values: contractinfo?.find(item => item?.keys === '매도인전화')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '매수인주소' ? {...item, values: contractinfo?.find(item => item?.keys === '매수인주소')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '매수인주민번호' ? {...item, values: contractinfo?.find(item => item?.keys === '매수인주민번호')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '매수인전화' ? {...item, values: contractinfo?.find(item => item?.keys === '매수인전화')?.values } : item);

            // inputArrData = inputArrData?.map(item => item?.keys === '개중등록번호1' ? {...item, values: contractinfo?.find(item => item?.keys === '개중등록번호1')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '개중사무소명칭1' ? {...item, values: contractinfo?.find(item => item?.keys === '개중사무소명칭1')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '개중사무소소재지1' ? {...item, values: contractinfo?.find(item => item?.keys === '개중사무소소재지1')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '개중전화번호1' ? {...item, values: contractinfo?.find(item => item?.keys === '개중전화번호1')?.values } : item);

            // inputArrData = inputArrData?.map(item => item?.keys === '개중등록번호2' ? {...item, values: contractinfo?.find(item => item?.keys === '개중등록번호2')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '개중사무소명칭2' ? {...item, values: contractinfo?.find(item => item?.keys === '개중사무소명칭2')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '개중사무소소재지2' ? {...item, values: contractinfo?.find(item => item?.keys === '개중사무소소재지2')?.values } : item);
            // inputArrData = inputArrData?.map(item => item?.keys === '개중전화번호2' ? {...item, values: contractinfo?.find(item => item?.keys === '개중전화번호2')?.values } : item);
        }

        if(inputArr?.find(item => item?.keys === '건축물선택')?.values === '임대'){
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-용도지역' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-용도지구' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-용도구역' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-건폐율상한' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지역지구-용적률상한' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-도시군계획시설' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-허가신고구역여부' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-투기지역여부' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-지구단위계획구역' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '토지이용계획-그밖의이용제한' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '개별공시지가' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '건물주택공시가격' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '취득세' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '농어촌특별세' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
            inputArrData = inputArrData?.map(item => item?.keys === '지방교육세' ? {...item, requireCkr: false, values: '(임대차생략)'} : item);
        }

        setinputArr(inputArrData);

    }, [inputArr?.find(item => item?.keys === '건축물선택')?.values]);

    const datavaluesFunc = (fkeys='', fkeys2='', indexn = '', data) => {
        //console.log(inputArr);
        //return;
        setinputArr(inputArr?.map((x, i) => {
            if(x?.keys === fkeys){
                return {...x, values: x?.values?.map((x2, i2) => {
                    return {...x, subflag: x2?.subflag, values: x2?.values?.map((x3, i3) => {
                        if(x3?.keys === fkeys2 && i2 === indexn){
                            return {...x3, values: data};
                        } else {
                            return x3;
                        }
                    })}
                })}
            } else {
                return x;
            }
        }));    
    }

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', gap: 10}}>
            <div>
                ■ 공인중개사법 시행규칙 [별지 제20호서식] &lt;<span style={{ color: 'blue' }}>개정 2021. 12. 31.</span>&gt;
            </div>
            <div 
                className='fontsize12' 
                style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 8,
                    flexDirection: 'column'
                }}
            >
                <div className='bolds fontsize24'>
                    <b style={{ fontWeight: 800 }} className='fontsize24'>중개대상물 확인·설명서[I]</b> (주거용 건축물)                     
                </div>
                <div
                style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 8,
                }}                
                >
                    <span>(주택 유형 : </span>
                        <Radios
                            linetype={'checkimg'}
                            setvalues={(e) => {
                                setinputArr(inputArr?.map(item => item?.keys === '건축물선택' ? {...item, values: e} : item));
                            }}
                            values={inputArr?.find(item => item?.keys === '건축물선택')?.values}

                            namevalue={[
                                {names: '단독주택', values: '단독주택'},
                                {names: '공동주택', values: '공동주택'},
                                {names: '주거용 오피스텔', values: '주거용 오피스텔'},
                            ]}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                        />  
                    <span>)</span>    
                </div>

                <div
                style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', gap: 8,
                }}                
                >
                    <span>(거래 형태</span>
                        <Radios
                            linetype={'checkimg'}
                            setvalues={(e) => {
                                setinputArr(inputArr?.map(item => item?.keys === '건축물선택' ? {...item, values: e} : item));
                            }}
                            values={inputArr?.find(item => item?.keys === '건축물선택')?.values}

                            namevalue={[
                                {names: '매매·교환', values: '매매·교환'},
                                {names: '임대', values: '임대'},
                            ]}
                            fontweights={400}
                            fontSizes={14}
                            sizes={20}
                        />  
                    <span>)</span>    
                </div>
            </div>
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>확인·설명<br />자료</td>
                        <td colSpan={4} className='alignc'>확인·설명<br />근거자료 등</td>
                        <td colSpan={23} style={{ borderRightWidth: 0 }}>
                            <Checkbox
                                linetype={'checkimg'}
                                values={checkvalues}
                                setvalues={(e) => {
                                    console.log(e);
                                    setcheckvalues(e);
                                    setinputArr(inputArr?.map(item => item?.keys === '설명근거자료' ? {...item, values: e?.length > 0 ? e: ''} : item));
                                }}
                                namevalue={[
                                    {names: '등기권리증', values: 0},
                                    {names: '등기사항증명서', values: 1},
                                    {names: '토지대장', values: 2},
                                    {names: '건축물대장', values: 3},
                                    {names: '지적도', values: 4},
                                    {names: '임야도', values: 5},
                                    {names: '토지이용계획확인서', values: 6},
                                    {names: '확정일자 부여현황', values: 8},
                                    {names: '전입세대확인서', values: 9},
                                    {names: '국세납세증명서', values: 10},
                                    {names: '지방세납세증명서', values: 11},
                                    {names: '그 밖의 자료', values: 7, inputs: true, inputsetvalue: (e) => { setetcText1(e); }, inputvalue: etcText1},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                            />  
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} className='alignc'>대상물건의<br />상태에 관한<br />자료요구 사항</td>
                        <td colSpan={23} style={{ padding: 0, borderRightWidth: 0 }} >
                            <textarea className='contractTextarea' style={{ height: 100}}
                                onChange={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건요구사항' ? {...item, values: e.target.value} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건요구사항')?.values}                            
                            ></textarea>
                        </td>
                    </tr>
                </table>
            </div>  
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <th colSpan={12} className='alignc' style={{ borderLeftWidth: 0, borderRightWidth: 0 }} >유의사항</th>
                    </tr>
                    <tr>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0, width: 100 }}>개업공인중개사의 확인·설명 의무</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>개업공인중개사는 중개대상물에 관한 권리를 취득하려는 중개의뢰인에게 성실ᆞ정확 하게 설명하고, 토지대장 등본, 등기사항증명서 등 설명의 근거자료를 제시해야 합니다.</td>
                    </tr>
                    <tr>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0, width: 100 }}>실제 거래가격 신고</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>「부동산 거래신고 등에 관한 법률」 제3조 및 같은 법 시행령 별표 1 제1호마목에 따른 실 제 거래가격은 매수인이 매수한 부동산을 양도하는 경우 「소득세법」 제97조제1항 및 제7항과 같은 법 시행령 제163조제11항제2호에 따라 취득 당시의 실제 거래가액으로 보아 양도차익이 계산될 수 있음을 유의하시기 바랍니다.</td>
                    </tr>
                </table>
            </div>        

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} className='bolds'>I. 개업공인중개사 기본 확인사항</td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={9}>① 대상물건의 표시</td>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>토지</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>소재지</td>
                        <td colSpan={22} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-소재지' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-소재지')?.values}
                                name="mb_phone"
                            /> 
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>면적(m²)</td>
                        <td colSpan={8} rowSpan={2}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="㎡"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-면적' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-면적')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 32, textAlign: 'right'
                                }}
                            />                            
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>지목</td>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>공부상 지목</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-지목-공부상지목' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-지목-공부상지목')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />                            
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>실제 이용 상태</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-지목-실제이용상태' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-지목-실제이용상태')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />                            
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={6}>건축물</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>전용면적(m²)</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="㎡"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-전용면적' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-전용면적')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 32, textAlign: 'right'
                                }}
                            />                            
                        </td>
                        <td colSpan={4} className='alignc' >대지지분(m²)</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="㎡"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-대지지분' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-대지지분')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 32, textAlign: 'right'
                                }}
                            />                            
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>준공년도<br />(증개축년도)</td>
                        <td colSpan={8} rowSpan={2}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-준공년도' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-준공년도')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />                             
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>용도</td>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>건축물대장상 용도</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-건축물대장상용도' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-건축물대장상용도')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />                             
                        </td>
                    </tr>          
                    <tr>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }}>실제 용도</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-실제용도' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-실제용도')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />                             
                        </td>
                    </tr>    
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }}>구조</td>
                        <td colSpan={8} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-구조' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-구조')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />                             
                        </td>
                        <td colSpan={5} className='alignc' >방향</td>
                        <td colSpan={9} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <div>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-방향' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-방향')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />                                 
                                </div>
                                <div className='displayflexstart' style={{ gap: 4 }}>
                                    <span style={{ width: 40 }}>(기준 : </span>
                                    <div style={{ width: 60 }}>
                                    <Input 
                                        className={`inputs`}
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-기준' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-기준')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />   
                                    </div>                          
                                    )
                                </div>
                            </div>
                        </td>
                    </tr>   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, fontSize: 11, letterSpacing: -1 }}>내진설계 적용여부</td>
                        <td colSpan={8} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-내진설계적용여부' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-내진설계적용여부')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            /> 
                        </td>
                        <td colSpan={7} className='alignc' >내진능력</td>
                        <td colSpan={7} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-내진능력' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-내진능력')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            /> 
                        </td>
                    </tr>                      
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0, fontSize: 12, letterSpacing: -1 }}>건축물대장상<br />위반건축물 여부</td>
                        <td colSpan={8} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    console.log(e);
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-위반건축물여부' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-위반건축물여부')?.values}
                                namevalue={[
                                    {names: '위반', values: '위반'},
                                    {names: '적법', values: '적법'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />                              
                        </td>
                        <td colSpan={3} className='alignc' >위반내용</td>
                        <td colSpan={11} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '대상물건의표시-토지-건축물-위반내용' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '대상물건의표시-토지-건축물-위반내용')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            /> 
                        </td>
                    </tr>                     
                </table>
            </div>    

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>
                            ② 권리관계
                            {inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.length === 0 &&
                                <div
                                    style={{
                                        display: 'flex', alignItems: 'center', justifyItems: 'center', flexDirection: 'row',
                                        marginTop: 5,
                                    }}
                                >
                                    <button
                                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50%' }}
                                        onClick={() => {
                                            let saveArr = [...inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values];
                                            saveArr.push({keys: "토지건축물1", values: [
                                                {keys: "토지1", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-토지-추가')+' 입력해주세요.'},
                                                    {keys: "토지2", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-토지-추가')+' 입력해주세요.'},
                                                    {keys: "건축물1", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-건축물-추가')+' 입력해주세요.'},
                                                    {keys: "건축물2", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-건축물-추가')+' 입력해주세요.'},
                                            ], requireCkr: true, errmsg: ''});

                                            setinputArr(inputArr?.map((x, i) => {
                                                if(x?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가'){
                                                    return {...x, values: saveArr}
                                                } else {
                                                    return x;
                                                }
                                            }));
                                        }}
                                    >
                                        <img src="./images/icons/addplus.svg" width='16' />
                                    </button>
                                </div>                            
                            }
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>등기부 기재사항</td>
                        <td colSpan={12} className='alignc' style={{ borderLeftWidth: 0 }}>소유권에 관한 사항</td>
                        <td colSpan={12} className='alignc' style={{ borderRightWidth: 0 }}>소유권 외의 권리사항</td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >토지</td>
                        <td colSpan={9} style={{ borderRightWidth: 0 }}>
                            <textarea 
                                className='contractTextarea' 
                                style={{ height: 92}}
                                onChange={(e) => {
                                    var rows = e.target.value.split('\n').length;
                                    var maxRows = 5;
                                    if( rows > maxRows){
                                        return;
                                    }
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지' ? {...item, values: e.target.value} : item));                                        
                                }}
                                value={inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지')?.values}
                            ></textarea>
                        </td>
                        <td colSpan={3} className='alignc' >토지</td>
                        <td colSpan={9} style={{ borderRightWidth: 0 }}>
                            <textarea 
                                className='contractTextarea' 
                                style={{ height: 92}}
                                onChange={(e) => {
                                    var rows = e.target.value.split('\n').length;
                                    var maxRows = 5;
                                    if( rows > maxRows){
                                        return;
                                    }
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-등기부기재사항-소유권외의권리사항-토지' ? {...item, values: e.target.value} : item));                                        
                                }}
                                value={inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권외의권리사항-토지')?.values}
                            ></textarea>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >건축물</td>
                        <td colSpan={9} style={{ borderRightWidth: 0 }}>
                            <textarea 
                                className='contractTextarea' 
                                style={{ height: 92}}
                                onChange={(e) => {
                                    var rows = e.target.value.split('\n').length;
                                    var maxRows = 5;
                                    if( rows > maxRows){
                                        return;
                                    }
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-건축물' ? {...item, values: e.target.value} : item));                                        
                                }}
                                value={inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-건축물')?.values}
                            ></textarea>                                                 
                        </td>
                        <td colSpan={3} className='alignc' >건축물</td>
                        <td colSpan={9} style={{ borderRightWidth: 0 }}>
                            <textarea 
                                className='contractTextarea' 
                                style={{ height: 92}}
                                onChange={(e) => {
                                    var rows = e.target.value.split('\n').length;
                                    var maxRows = 5;
                                    if( rows > maxRows){
                                        return;
                                    }
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-등기부기재사항-소유권외의권리사항-건축물' ? {...item, values: e.target.value} : item));                                        
                                }}
                                value={inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권외의권리사항-건축물')?.values}
                            ></textarea>                         
                        </td>
                    </tr>
                </table>
            </div>
            
            {inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.map((x, i) => {
                let rowspan = inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.length;
                let indexNumber = i;

                // {keys: "권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가", values: [
                //     {keys: "토지1", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-토지-추가')+' 입력해주세요.'},
                //     {keys: "토지2", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-토지-추가')+' 입력해주세요.'},
                //     {keys: "건축물1", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-건축물-추가')+' 입력해주세요.'},
                //     {keys: "건축물2", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-건축물-추가')+' 입력해주세요.'},
                // ], requireCkr: false, errmsg: '특약사항을 입력해주세요.'},
                return (
                    <div 
                        className='fontsize12' style={{ width: '100%' }}
                    >
                        <table className='contractTable lrbordernone'>
                            <tr>
                                <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>
                                    ② 권리관계
                                    {rowspan-1 === i &&
                                    <div
                                        style={{
                                            display: 'flex', alignItems: 'center', justifyItems: 'center', flexDirection: 'row',
                                            marginTop: 5,
                                        }}
                                    >
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50%' }}
                                            onClick={() => {
                                                let saveArr = [...inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values];
                                                saveArr.push({keys: "토지건축물"+rowspan, values: [
                                                    {keys: "토지1", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-토지-추가')+' 입력해주세요.'},
                                                        {keys: "토지2", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-토지-추가')+' 입력해주세요.'},
                                                        {keys: "건축물1", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-건축물-추가')+' 입력해주세요.'},
                                                        {keys: "건축물2", values: '', requireCkr: false, errmsg: heckName('권리관계-등기부기재사항-소유권에관한사항-건축물-추가')+' 입력해주세요.'},
                                                ], requireCkr: true, errmsg: ''});

                                                console.log(saveArr);
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가'){
                                                        return {...x, values: saveArr}
                                                    } else {
                                                        return x;
                                                    }
                                                }));
                                            }}
                                        >
                                            <img src="./images/icons/addplus.svg" width='16' />
                                        </button>
                                        <button
                                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '50%' }}
                                            onClick={() => {
                                                let saveArr = [...inputArr?.find(item => item?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가')?.values?.filter((item, index) => index !== rowspan-1)];
                                                setinputArr(inputArr?.map((x, i) => {
                                                    if(x?.keys === '권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가'){
                                                        return {...x, values: saveArr}
                                                    } else {
                                                        return x;
                                                    }
                                                }));

                                            }}
                                        >
                                            <img src="./images/icons/adddelete.svg" width='16' />
                                        </button>
                                    </div>}                                     
                                </td>
                                <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>등기부 기재사항</td>
                                <td colSpan={12} className='alignc' style={{ borderLeftWidth: 0 }}>소유권에 관한 사항</td>
                                <td colSpan={12} className='alignc' style={{ borderRightWidth: 0 }}>소유권 외의 권리사항</td>
                            </tr>
                            <tr>
                                <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >토지</td>
                                <td colSpan={9} style={{ borderRightWidth: 0 }}>
                                    <textarea 
                                        className='contractTextarea' 
                                        style={{ height: 302}}
                                        onChange={(e) => {
                                            var rows = e.target.value.split('\n').length;
                                            var maxRows = 20;
                                            if( rows > maxRows){
                                                return;
                                            }
                                            datavaluesFunc('권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가', '토지1', indexNumber, e.target.value);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '토지1')?.values}
                                    ></textarea>
                                </td>


                                <td colSpan={3} className='alignc' >토지</td>
                                <td colSpan={9} style={{ borderRightWidth: 0 }}>
                                    <textarea 
                                        className='contractTextarea' 
                                        style={{ height: 302}}
                                        onChange={(e) => {
                                            var rows = e.target.value.split('\n').length;
                                            var maxRows = 20;
                                            if( rows > maxRows){
                                                return;
                                            }                                            
                                            datavaluesFunc('권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가', '토지2', indexNumber, e.target.value);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '토지2')?.values}
                                    ></textarea>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >건축물</td>
                                <td colSpan={9} style={{ borderRightWidth: 0 }}>
                                    <textarea 
                                        className='contractTextarea' 
                                        style={{ height: 302}}
                                        onChange={(e) => {
                                            var rows = e.target.value.split('\n').length;
                                            var maxRows = 20;
                                            if( rows > maxRows){
                                                return;
                                            }                                            
                                            datavaluesFunc('권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가', '건축물1', indexNumber, e.target.value);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '건축물1')?.values}
                                    ></textarea>                                                 
                                </td>
                                <td colSpan={3} className='alignc' >건축물</td>
                                <td colSpan={9} style={{ borderRightWidth: 0 }}>
                                    <textarea 
                                        className='contractTextarea' 
                                        style={{ height: 302}}
                                        onChange={(e) => {
                                            var rows = e.target.value.split('\n').length;
                                            var maxRows = 20;
                                            if( rows > maxRows){
                                                return;
                                            }                                            
                                            datavaluesFunc('권리관계-등기부기재사항-소유권에관한사항-토지건축물-추가', '건축물2', indexNumber, e.target.value);
                                        }}
                                        value={x?.values?.find(item => item?.keys === '건축물2')?.values}
                                    ></textarea>                         
                                </td>
                            </tr>
                        </table>
                    </div>
                );
            })}
                        
            
            
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={6}>③ 토지이용 계획, 공법상 이용 제한 및 거래 규제에 관한 사항(토지)</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>지역·지구</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >용도지역</td>
                        <td colSpan={15} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-지역지구-용도지역' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지이용계획-지역지구-용도지역')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />                            
                        </td>
                        <td colSpan={3} className='alignc' >건폐율 상한</td>
                        <td colSpan={3} className='alignc' style={{ borderRightWidth: 0 }}>용적률 상한</td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >용도지구</td>
                        <td colSpan={15} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-지역지구-용도지구' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지이용계획-지역지구-용도지구')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderRightWidth: 0 }} rowSpan={2}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="%"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-지역지구-건폐율상한' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지이용계획-지역지구-건폐율상한')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 28, textAlign: 'right'
                                }}
                            />
                        </td>
                        <td colSpan={3} className='alignc' style={{ borderRightWidth: 0 }} rowSpan={2}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="%"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-지역지구-용적률상한' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지이용계획-지역지구-용적률상한')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 28, textAlign: 'right'
                                }}
                            />                          
                        </td>

                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >용도구역</td>
                        <td colSpan={15} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-지역지구-용도구역' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지이용계획-지역지구-용도구역')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>도시·군계획 시설</td>
                        <td colSpan={9} style={{ borderRightWidth: 0 }} rowSpan={2}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-도시군계획시설' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지이용계획-도시군계획시설')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                        <td colSpan={3} className='alignc' >허가·신고 구역 여부</td>
                        <td colSpan={12} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-허가신고구역여부' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '토지이용계획-허가신고구역여부')?.values}
                                namevalue={[
                                    {names: '토지거래허가구역', values: '토지거래허가구역'},
                                    {names: '(임대차생략)', values: '(임대차생략)'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' >투기지역 여부</td>
                        <td colSpan={12} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-투기지역여부' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '토지이용계획-투기지역여부')?.values}
                                namevalue={[
                                    {names: '토지투기지역', values: '토지투기지역'},
                                    {names: '주택투기지역', values: '주택투기지역'},
                                    {names: '투기과열지구', values: '투기과열지구'},
                                    {names: '(임대차생략)', values: '(임대차생략)'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >지구단위계획구역,<br />그 밖의 도시·군관리계획</td>
                        <td colSpan={8} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-지구단위계획구역' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지이용계획-지구단위계획구역')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                        <td colSpan={5} className='alignc' >그 밖의 이용제한 및 거래규제사항</td>
                        <td colSpan={8} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '토지이용계획-그밖의이용제한' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '토지이용계획-그밖의이용제한')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                    </tr>
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={7}>
                            ④임대차 확인사항
                        </td>                        
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >확정일자 부여현황 정보</td>
                        <td colSpan={15} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-확정일자부여현황정보-등록-선택사항' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '권리관계-확정일자부여현황정보-등록-선택사항')?.values}
                                namevalue={[
                                    {names: '임대인 자료 제출', values: '임대인 자료 제출'},
                                    {names: '열람 동의', values: '열람 동의'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={180}
                            />
                        </td>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 1 }} rowSpan={1}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-확정일자부여현황정보-등록-임차인권리설명' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '권리관계-확정일자부여현황정보-등록-임차인권리설명')?.values}

                                namevalue={[
                                    {names: '임차인 권리 설명', values: '임차인 권리 설명'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />  
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >국세 및 지방세 체납정보</td>
                        <td colSpan={15} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-국세및지방세체납정보-등록-선택사항' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '권리관계-국세및지방세체납정보-등록-선택사항')?.values}
                                namevalue={[
                                    {names: '임대인 자료 제출', values: '임대인 자료 제출'},
                                    {names: '열람 동의', values: '열람 동의'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={180}
                            />
                        </td>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 1 }} rowSpan={1}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-국세및지방세체납정보-등록-임차인권리설명' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '권리관계-국세및지방세체납정보-등록-임차인권리설명')?.values}

                                namevalue={[
                                    {names: '임차인 권리 설명', values: '임차인 권리 설명'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />  
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >전입세대 확인서</td>
                        <td colSpan={21} className='alignc' style={{ borderRightWidth: 1 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-전입세대확인서-등록-선택사항' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '권리관계-전입세대확인서-등록-선택사항')?.values}
                                namevalue={[
                                    {names: '확인(확인서류 첨부)', values: '확인(확인서류 첨부)'},
                                    {names: '미확인(열람ᆞ교부 신청방법 설명)', values: '미확인(열람ᆞ교부 신청방법 설명)'},
                                    {names: '해당 없음', values: '해당 없음'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={180}
                            />
                        </td>
                    </tr>                    
                    <tr>
                    
                        <td colSpan={1} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>민간 임대 등록 여부</td>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>등록</td>
                        <td colSpan={18} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-민간임대등록여부-등록-선택사항' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '권리관계-민간임대등록여부-등록-선택사항')?.values}
                                namevalue={[
                                    {names: '장기일반민간임대주택', values: '장기일반민간임대주택'},
                                    {names: '공공지원민간임대주택', values: '공공지원민간임대주택'},
                                    {names: '그 밖의 유형', values: '그 밖의 유형', inputs: true, inputsetvalue: (e) => { setetcText2(e); }, inputvalue: etcText2},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={180}
                            />
                        </td>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 1 }} rowSpan={1}>

                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-민간임대등록여부-등록-임대보증금보증설명' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '권리관계-민간임대등록여부-등록-임대보증금보증설명')?.values}

                                namevalue={[
                                    {names: '임대보증금 보증 설명', values: '임대보증금 보증 설명'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />  
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={4} className='alignc' style={{ borderLeftWidth: 0 }} >임대의무기간</td>
                        <td colSpan={5} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-민간임대등록여부-등록-임대의무기간' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '권리관계-민간임대등록여부-등록-임대의무기간')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            /> 
                        </td>
                        <td colSpan={4} className='alignc' style={{ wordBreak: 'keep-all' }} >임대개시일</td>
                        <td colSpan={5} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-민간임대등록여부-등록-임대개시일' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '권리관계-민간임대등록여부-등록-임대개시일')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            /> 
                        </td>
                        <td colspan={6}></td>
                    </tr>
                    <tr>
                        <td colSpan={26} className='alignc' style={{ borderLeftWidth: 0 }} >
                            <Checkbox
                                linetype={'checkimg'}
                                values={checkvalues2}
                                setvalues={(e) => {
                                    setcheckvalues2(e);
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-민간임대등록여부-미등록' ? {...item, values: e?.length > 0 ? e: ''} : item));
                                }}
                                namevalue={[
                                    {names: '미등록', values: 0},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >계약갱신 요구권 행사 여부</td>
                        <td colSpan={24} className='alignc' style={{ borderRightWidth: 1 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '권리관계-계약갱신요구권행사여부' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '권리관계-계약갱신요구권행사여부')?.values}
                                namevalue={[
                                    {names: '확인(확인서류첨부)', values: '확인(확인서류첨부)'},
                                    {names: '미확인', values: '미확인'},
                                    {names: '해당없음', values: '해당없음'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={14} className='' style={{ borderLeftWidth: 0 }} rowSpan={4}>
                            개업공인중개사가 “④ 임대차 확인사항”을 임대인 및 임차인에 게 설명하였음을 확인함
                        </td>                        
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >{row?.sell_type === '매매' ? '매도인' : '임대인'}</td>
                        <td colSpan={10} style={{ textAlign: 'right' }}>
                            (서명 또는 날인)
                        </td>
                    </tr>                    
                    <tr>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >{row?.sell_type === '매매' ? '매수인' : '임대인'}</td>
                        <td colSpan={10} style={{ textAlign: 'right' }}>
                            (서명 또는 날인)
                        </td>
                    </tr>                    
                    <tr>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >개업공인중개사</td>
                        <td colSpan={10} style={{ textAlign: 'right' }}>
                            (서명 또는 날인)
                        </td>
                    </tr>                    
                    <tr>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >개업공인중개사</td>
                        <td colSpan={10} style={{ textAlign: 'right' }}>
                            (서명 또는 날인)
                        </td>
                    </tr>         
                    <tr>
                        <td colSpan={30} className='' style={{ borderLeftWidth: 0, borderRightWidth: 0 }} >
                        ※ 민간임대주택의 임대사업자는 「민간임대주택에 관한 특별법」 제49조에 따라 임대보증금에 대한 보증에 가입해야 합니다. <br />
                        ※ 임차인은 주택도시보증공사(HUG) 등이 운영하는 전세보증금반환보증에 가입할 것을 권고합니다. <br />
                        ※ 임대차 계약 후 「부동산 거래신고 등에 관한 법률」 제6조의2에 따라 30일 이내 신고해야 합니다(신고 시 확정일자 자동부여).  <br />
                        ※ 최우선변제금은 근저당권 등 선순위 담보물권 설정 당시의 소액임차인범위 및 최우선변제금액을 기준으로 합니다.
                        </td>                        
                    </tr>  

                </table>
            </div>


            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={7}>⑤ 입지조건</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >도로와의 관계</td>
                        <td colSpan={16} style={{ borderRightWidth: 0 }}> 
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                (
                                <div style={{ width: 80 }}>
                                    <Input 
                                        className={`inputs`}
                                        rightplaceholder="m"
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-도로와의관계1' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-도로와의관계1')?.values}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 28, textAlign: 'right'
                                        }}
                                    />
                                </div>
                                x
                                <div style={{ width: 80 }}>
                                    <Input 
                                        className={`inputs`}
                                        rightplaceholder="m"
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-도로와의관계2' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-도로와의관계2')?.values}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 28, textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )
                                도로에접함

                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '입지조건-도로와의관계3' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '입지조건-도로와의관계3')?.values}
                                    namevalue={[
                                        {names: '포장', values: '포장'},
                                        {names: '비포장', values: '비포장'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                            </div>
                        </td>
                        <td colSpan={2} className='alignc' >접근성</td>
                        <td colSpan={6} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '입지조건-도로와의관계-접근성' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '입지조건-도로와의관계-접근성')?.values}
                                namevalue={[
                                    {names: '용이함', values: '용이함'},
                                    {names: '불편함', values: '불편함'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </td>
                    </tr>
                    
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>대중교통</td>
                        <td colSpan={3} className='alignc' >버스</td>
                        <td colSpan={21} className='alignc' style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                (
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-대중교통-버스' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-대중교통-버스')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )
                                정류장, 
                                소요시간: (

                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '입지조건-대중교통-버스2' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '입지조건-대중교통-버스2')?.values}
                                    namevalue={[
                                        {names: '도보', values: '도보'},
                                        {names: '차량', values: '차량'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                )
                                약 
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        rightplaceholder="분"
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-대중교통-버스3' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-대중교통-버스3')?.values}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 28, textAlign: 'right'
                                        }}
                                    />
                                </div>                                
                            </div>                            
                        </td>
                    </tr>
                    
                    <tr>
                        <td colSpan={3} className='alignc' >지하철</td>
                        <td colSpan={21} className='alignc' style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                (
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-대중교통-지하철1' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-대중교통-지하철1')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )
                                역, 
                                소요시간: (

                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '입지조건-대중교통-지하철2' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '입지조건-대중교통-지하철2')?.values}
                                    namevalue={[
                                        {names: '도보', values: '도보'},
                                        {names: '차량', values: '차량'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                )
                                약 
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        rightplaceholder="분"
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-대중교통-지하철3' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-대중교통-지하철3')?.values}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 28, textAlign: 'right'
                                        }}
                                    />
                                </div>                                
                            </div>                             
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >주차장</td>
                        <td colSpan={24} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '입지조건-주차장1' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '입지조건-주차장1')?.values}
                                namevalue={[
                                    {names: '없음', values: '없음'},
                                    {names: '전용주차시설', values: '전용주차시설'},
                                    {names: '공동주차시설', values: '공동주차시설'},
                                    {names: '그밖의주차시설', values: '그밖의주차시설', inputs: true, inputsetvalue: (e) => { setetcText3(e) }, inputvalue: etcText3},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                            />                            
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>교육시설</td>
                        <td colSpan={3} className='alignc' >초등학교</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                (
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-초등학교1' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-교육시설-초등학교1')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )
                                학교, 
                                소요시간: (

                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-초등학교2' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '입지조건-교육시설-초등학교2')?.values}
                                    namevalue={[
                                        {names: '도보', values: '도보'},
                                        {names: '차량', values: '차량'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                )
                                약 
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        rightplaceholder="분"
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-초등학교3' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-교육시설-초등학교3')?.values}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 28, textAlign: 'right'
                                        }}
                                    />
                                </div>                                
                            </div>                            
                        </td>
                    </tr>
                    
                    <tr>
                        <td colSpan={3} className='alignc' >중학교</td>
                        <td colSpan={21} className='alignc' style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                (
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-중학교1' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-교육시설-중학교1')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )
                                학교, 
                                소요시간: (

                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-중학교2' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '입지조건-교육시설-중학교2')?.values}
                                    namevalue={[
                                        {names: '도보', values: '도보'},
                                        {names: '차량', values: '차량'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                )
                                약 
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        rightplaceholder="분"
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-중학교3' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-교육시설-중학교3')?.values}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 28, textAlign: 'right'
                                        }}
                                    />
                                </div>                                
                            </div>                             
                        </td>
                    </tr>
                    
                    <tr>
                        <td colSpan={3} className='alignc' >고등학교</td>
                        <td colSpan={21} className='alignc' style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                (
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-고등학교1' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-교육시설-고등학교1')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )
                                학교, 
                                소요시간: (

                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-고등학교2' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '입지조건-교육시설-고등학교2')?.values}
                                    namevalue={[
                                        {names: '도보', values: '도보'},
                                        {names: '차량', values: '차량'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                )
                                약 
                                <div style={{ width: 100 }}>
                                    <Input 
                                        className={`inputs`}
                                        rightplaceholder="분"
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '입지조건-교육시설-고등학교3' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '입지조건-교육시설-고등학교3')?.values}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 28, textAlign: 'right'
                                        }}
                                    />
                                </div>                                
                            </div>                             
                        </td>
                    </tr>
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2} >⑥ 관리에 관한사항</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >경비실</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '관리에관한사항-경비실' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '관리에관한사항-경비실')?.values}
                                namevalue={[
                                    {names: '있음', values: '있음'},
                                    {names: '없음', values: '없음'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </td>
                        <td colSpan={3} className='alignc' >관리주체</td>
                        <td colSpan={11} className='alignc' style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '관리에관한사항-관리주체' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '관리에관한사항-관리주체')?.values}
                                namevalue={[
                                    {names: '위탁관리', values: '위탁관리'},
                                    {names: '자체관리', values: '자체관리'},
                                    {names: '그밖의유형', values: '그밖의유형'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />                            
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >관리비</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                관리비 금액 : 총 
                                <div style={{ width: 180 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '관리에관한사항-관리비-관리비금액' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '관리에관한사항-관리비-관리비금액')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                원
                            </div>
                            <div className='displayflexstart' style={{ gap: 4, marginTop: 5  }}>
                                관리비 포함 비목 :  
                                <div style={{ width: 'calc(100% - 200px)' }}>
                                    <Radios
                                        linetype={'checkimg'}
                                        setvalues={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '관리에관한사항-관리비-관리비포함비목' ? {...item, values: e} : item));
                                        }}
                                        values={inputArr?.find(item => item?.keys === '관리에관한사항-관리비-관리비포함비목')?.values}
                                        namevalue={[
                                            {names: '전기료', values: '전기료'},
                                            {names: '수도료', values: '수도료'},
                                            {names: '가스사용료', values: '가스사용료'},
                                            {names: '난방비', values: '난방비'},
                                            {names: '인터넷사용료', values: '인터넷사용료'},
                                            {names: 'TV수신료', values: 'TV수신료'},
                                            {names: '그밖의비목', values: '그밖의비목', inputs: true, inputsetvalue: (e) => { setetcText18(e) }, inputvalue: etcText18},
                                        ]}
                                        fontweights={400}
                                        fontSizes={14}
                                        sizes={20}
                                    />   
                                    
                                </div>
                                
                            </div>
                            <div className='displayflexstart' style={{ gap: 4, marginTop: 5  }}>
                                관리비 부과방식 :  
                                <div style={{ width: 'calc(100% - 250px)' }}>
                                    <Radios
                                        linetype={'checkimg'}
                                        setvalues={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '관리에관한사항-관리비-관리비부과방식' ? {...item, values: e} : item));
                                        }}
                                        values={inputArr?.find(item => item?.keys === '관리에관한사항-관리비-관리비부과방식')?.values}
                                        namevalue={[
                                            {names: '임대인이직접부과', values: '임대인이직접부과'},
                                            {names: '관리규약에따라부과', values: '관리규약에따라부과'},
                                            {names: '그밖의부과방식', values: '그밖의부과방식', inputs: true, inputsetvalue: (e) => { setetcText19(e) }, inputvalue: etcText19},
                                        ]}
                                        fontweights={400}
                                        fontSizes={14}
                                        sizes={20}
                                    />   
                                    
                                </div>
                                
                            </div>
                        </td>
                    </tr>

                </table>
            </div>
            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={6} className='alignc' style={{ borderLeftWidth: 0 }} >⑦ 비선호시설(1km이내)</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '비선호시설' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '비선호시설')?.values}
                                    namevalue={[
                                        {names: '없음', values: '없음'},
                                        {names: '있음', values: '있음'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                (종류 및 위치 : 
                                <div style={{ width: 200 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={setetcText4}
                                        value={etcText4}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )                              
                            </div>                               
                        </td>
                    </tr>
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>⑧ 거래예정금액 등</td>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} >거래예정금액</td>
                        <td colSpan={20} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '거래예정금액' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '거래예정금액')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />                            
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} >개별공시지가(m²당)</td>
                        <td colSpan={5} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개별공시지가' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개별공시지가')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                        <td colSpan={5} className='alignc' >건물(주택) 공시가격</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '건물주택공시가격' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '건물주택공시가격')?.values}
                                name="mb_phone"
                                style={{
                                    textAlign: 'right'
                                }}
                            />
                        </td>
                    </tr>
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={5} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>⑨ 취득 시 부담할 조세의 종류 및 세율</td>
                        <td colSpan={2} className='alignc' style={{ borderLeftWidth: 0 }} >취득세</td>
                        <td colSpan={5} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="%"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '취득세' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '취득세')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 28, textAlign: 'right'
                                }}
                            />                            
                        </td>
                        <td colSpan={3} className='alignc' >농어촌특별세</td>
                        <td colSpan={5} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="%"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '농어촌특별세' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '농어촌특별세')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 28, textAlign: 'right'
                                }}
                            />                            
                        </td>
                        <td colSpan={3} className='alignc' >지방교육세</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                rightplaceholder="%"
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '지방교육세' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '지방교육세')?.values}
                                name="mb_phone"
                                style={{
                                    paddingRight: 28, textAlign: 'right'
                                }}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={25} style={{ borderRightWidth: 0 }}>※ 재산세와 종합부동산세는 6월 1일 기준 대상물건 소유자가 납세의무를 부담합니다.</td>
                    </tr>
                </table>
            </div>



            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} className='bolds'>II. 개업공인중개사 세부 확인사항</td>
                    </tr>
                    <tr>
                        <td colSpan={30} style={{ border: 0 }} >⑩ 실제 권리관계 또는 공시되지 않은물건의 권리 사항</td>
                    </tr>
                    <tr>
                        <td colSpan={30} style={{ border: 0, padding: 0 }}>
                            <textarea className='contractTextarea' style={{ height: 100}}
                                onChange={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '실제권리관계또는공시되지않은물건의권리사항' ? {...item, values: e.target.value} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '실제권리관계또는공시되지않은물건의권리사항')?.values}                            
                            ></textarea>
                        </td>
                    </tr>             
                </table>
            </div>  

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={10}>⑪ 내부· 외부 시설물 의상태 (건축물)</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>수도</td>
                        <td colSpan={3} className='alignc' >파손 여부</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-수도-파손여부' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-수도-파손여부')?.values}
                                    namevalue={[
                                        {names: '없음', values: '없음'},
                                        {names: '있음', values: '있음'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                (위치 : 
                                <div style={{ width: 200 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={setetcText5}
                                        value={etcText5}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )                              
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' >용수량</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-수도-용수량' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-수도-용수량')?.values}
                                    namevalue={[
                                        {names: '정상', values: '정상'},
                                        {names: '부족함', values: '부족함'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                (위치 : 
                                <div style={{ width: 200 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={setetcText6}
                                        value={etcText6}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )                              
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >전기</td>
                        <td colSpan={3} className='alignc' >공급상태</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-전기-공급상태' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-전기-공급상태')?.values}
                                    namevalue={[
                                        {names: '정상', values: '정상'},
                                        {names: '교체 필요', values: '교체 필요'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                (교체할 부분 : 
                                <div style={{ width: 200 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={setetcText7}
                                        value={etcText7}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )                              
                            </div>
                        </td>
                    </tr>                    
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >가스(취사용)</td>
                        <td colSpan={3} className='alignc' >공급방식</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-가스-공급방식' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-가스-공급방식')?.values}
                                    namevalue={[
                                        {names: '도시가스', values: '도시가스'},
                                        {names: '그밖의방식', values: '그밖의방식', inputs: true, inputsetvalue: (e) => { setetcText8(e) }, inputvalue: etcText8},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                    heightsflag={true}
                                    inputswidth={200}
                                />
                            </div>
                        </td>
                    </tr>                    
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >소방</td>
                        <td colSpan={3} className='alignc' >단독경보형 감지기</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-소방-단독경보형감지기' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-소방-단독경보형감지기')?.values}
                                    namevalue={[
                                        {names: '없음', values: '없음'},
                                        {names: '있음', values: '있음'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                (수량 : 
                                <div style={{ width: 60 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={setetcText9}
                                        value={etcText9}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                개
                                )                              
                            </div>
                        </td>
                        <td colSpan={11} style={{ borderRightWidth: 0, fontSize: 9 }}>※ 「소방시설 설치 및 관리에 관한 법률」 제10조 및 같은 법 시행령 제10조에 따른 주택용 소방시설로서 아파트(주택으로 사용하는 층수가 5개층 이상인 주택을 말한다)를 제외한 주택의 경우만 적습니다.</td>
                    </tr>     
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>난방방식 및 연료공급</td>
                        <td colSpan={3} className='alignc' >공급방식</td>
                        <td colSpan={7} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-공급방식' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-공급방식')?.values}
                                namevalue={[
                                    {names: '중앙공급', values: '중앙공급'},
                                    {names: '개별공급', values: '개별공급'},
                                    {names: '지역난방', values: '지역난방'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </td>
                        <td colSpan={2} className='alignc' >시설작동</td>
                        <td colSpan={12} style={{ borderRightWidth: 0 }}>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-시설작동' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-시설작동')?.values}
                                    namevalue={[
                                        {names: '정상', values: '정상'},
                                        {names: '수선필요', values: '수선필요'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                                (
                                <div style={{ width: 60 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={setetcText10}
                                        value={etcText10}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )                              
                            </div>
                            <div className='displayflexstart' style={{ gap: 4, marginTop: 3 }}>
                                ※개별공급인경우사용연한(
                                <div style={{ width: 60 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={setetcText11}
                                        value={etcText11}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                                )                  
                                <Radios
                                    linetype={'checkimg'}
                                    setvalues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-시설작동' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-시설작동')?.values}
                                    namevalue={[
                                        {names: '확인불가', values: '확인불가'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />            
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' >종류</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-종류' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-난방방식및연료공급-종류')?.values}
                                namevalue={[
                                    {names: '도시가스', values: '도시가스'},
                                    {names: '기름', values: '기름'},
                                    {names: '프로판가스', values: '프로판가스'},
                                    {names: '연탄', values: '연탄'},
                                    {names: '그밖의종류', values: '그밖의종류', inputs: true, inputsetvalue: (e) => { setetcText12(e) }, inputvalue: etcText12},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                            />
                        </td>
                    </tr>       
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >승강기</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-승강기' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-승강기')?.values}
                                namevalue={[
                                    {names: '있음', values: '있음'},
                                    {names: '양호', values: '양호'},
                                    {names: '불량', values: '불량'},
                                    {names: '없음', values: '없음'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={200}
                            />
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >배수</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-배수' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '내부외부시설물의상태-배수')?.values}
                                namevalue={[
                                    {names: '정상', values: '정상'},
                                    {names: '수선필요', values: '수선필요', inputs: true, inputsetvalue: (e) => { setetcText13(e) }, inputvalue: etcText13},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >그 밖의 시설물</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '내부외부시설물의상태-그밖의시설물' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '내부외부시설물의상태-그밖의시설물')?.values}
                                name="mb_phone"
                            />
                        </td>
                    </tr>                                                   
                </table>
            </div>


            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={4}>⑫ 벽면ᆞ 바닥면 및 도배 상태</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>벽면</td>
                        <td colSpan={3} className='alignc' >균열</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '벽면바닥면및도배상태-벽면-균열' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-벽면-균열')?.values}
                                namevalue={[
                                    {names: '없음', values: '없음'},
                                    {names: '있음', values: '있음', inputs: true, inputsetvalue: (e) => { setetcText14(e) }, inputvalue: etcText14, input_title: <span style={{ display: 'flex', flexDirection: 'row', width: 40}}>위치:</span>},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' >누수</td>
                        <td colSpan={21} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '벽면바닥면및도배상태-벽면-누수' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-벽면-누수')?.values}
                                namevalue={[
                                    {names: '없음', values: '없음'},
                                    {names: '있음', values: '있음', inputs: true, inputsetvalue: (e) => { setetcText15(e) }, inputvalue: etcText15, input_title: <span style={{ display: 'flex', flexDirection: 'row', width: 40}}>위치:</span>},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                    </tr>
                     
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >바닥면</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '벽면바닥면및도배상태-바닥면' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-바닥면')?.values}
                                namevalue={[
                                    {names: '깨끗함', values: '깨끗함'},
                                    {names: '보통임', values: '보통임'},
                                    {names: '수리 필요', values: '수리 필요', inputs: true, inputsetvalue: (e) => { setetcText16(e) }, inputvalue: etcText16, input_title: <span style={{ display: 'flex', flexDirection: 'row', width: 40}}>위치:</span>},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >도배</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '벽면바닥면및도배상태-도배' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '벽면바닥면및도배상태-도배')?.values}
                                namevalue={[
                                    {names: '깨끗함', values: '깨끗함'},
                                    {names: '보통임', values: '보통임'},
                                    {names: '도배 필요', values: '도배 필요'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                    </tr>                                                   
                </table>
            </div>


            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>⑬ 환경 조건</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >일조량</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '환경조건-일조량' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '환경조건-일조량')?.values}
                                namevalue={[
                                    {names: '풍부함', values: '풍부함'},
                                    {names: '보통임', values: '보통임'},
                                    {names: '불충분', values: '불충분', inputs: true, inputsetvalue: (e) => { setetcText17(e) }, inputvalue: etcText17, input_title: <span style={{ display: 'flex', flexDirection: 'row', width: 40}}>이유:</span>},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >소음</td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '환경조건-소음' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '환경조건-소음')?.values}
                                namevalue={[
                                    {names: '아주 작음', values: '아주 작음'},
                                    {names: '보통임', values: '보통임'},
                                    {names: '심한 편임', values: '심한 편임'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                        <td colSpan={3} className='alignc' >진동</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '환경조건-진동' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '환경조건-진동')?.values}
                                namevalue={[
                                    {names: '아주 작음', values: '아주 작음'},
                                    {names: '보통임', values: '보통임'},
                                    {names: '심한 편임', values: '심한 편임'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                    </tr>                                                   
                </table>
            </div>


            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >⑭ 현장안내</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >현장안내자</td>
                        <td colSpan={24} style={{ borderRightWidth: 0 }}>
                            <Radios
                                linetype={'checkimg'}
                                setvalues={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '환경조건-일조량' ? {...item, values: e} : item));
                                }}
                                values={inputArr?.find(item => item?.keys === '환경조건-일조량')?.values}
                                namevalue={[
                                    {names: '개업공인중개사', values: '개업공인중개사'},
                                    {names: '소속공인중개사', values: '소속공인중개사'},
                                    {names: '중개보조원(신분고지:예)', values: '중개보조원(신분고지:예)'},
                                    {names: '중개보조원(신분고지:아니오)', values: '중개보조원(신분고지:아니오)'},
                                    {names: '해당 없음', values: '해당 없음'},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                                heightsflag={true}
                                inputswidth={250}
                            />
                        </td>
                    </tr>          
                    <tr>
                        <td colSpan={30} className='' style={{ borderLeftWidth: 0, borderRightWidth: 0 }} >
                        ※ “중개보조원”이란 공인중개사가 아닌 사람으로서 개업공인중개사에 소속되어 중개대상물에 대한 현장안내 및 일반서무 등 개업공인중개사의 중개업무와 관련된 단순한 업무를 보조하는 사람을 말합니다.<br />
                        ※ 중개보조원은 「공인중개사법」 제18조의4에 따라 현장안내 등 중개업무를 보조하는 경우 중개의뢰인에게 본인이 중개보조원이라는 사실을 미리 알려야 합니다.                            
                        </td>
                    </tr>                                               
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} className='bolds'>III. 중개보수 등에 관한 사항</td>
                    </tr>
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={4}>⑮ 중개보수 및 실비의 금액과 산출내역</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >중개보수</td>
                        <td colSpan={14} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '중개보수및실비의금액과산출내역-중개보수' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-중개보수')?.values}
                                name="mb_phone"
                            />
                        </td>
                        <td colSpan={10} style={{ borderRightWidth: 0 }} rowSpan={4}>
                            <div className='bolds'>&lt;산출내역&gt;</div>
                            <div className='displayflexstart' style={{ gap: 4 }}>
                                중개보수 : 
                                <div style={{ width: 180 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '중개보수및실비의금액과산출내역-작성일반중개보수' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-작성일반중개보수')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='displayflexstart' style={{ gap: 4, marginTop: 3 }}>
                                실　　비 : 
                                <div style={{ width: 180 }}>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={(e) => {
                                            setinputArr(inputArr?.map(item => item?.keys === '중개보수및실비의금액과산출내역-작성일반실비' ? {...item, values: e} : item));
                                        }}
                                        value={inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-작성일반실비')?.values}
                                        name="mb_phone"
                                        style={{
                                            textAlign: 'right'
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='contractmoreText2' style={{ padding: 0, marginTop: 8 }}>
                                <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                    <p className='fontsize12'>※</p>
                                    <p className='fontsize12'>중개보수는 시ᆞ도 조례로 정한 요율한도에서 중개의뢰인과 개업공인중개사가 서로 협의하여 결정하며 부가가치세는 별도로 부과될 수 있습니다.</p>
                                </div>
                            </div>
                        </td>

                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >실비</td>
                        <td colSpan={14} style={{ borderRightWidth: 0 }}> 
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '중개보수및실비의금액과산출내역-실비' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-실비')?.values}
                                name="mb_phone"
                            />     
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >계</td>
                        <td colSpan={14} style={{ borderRightWidth: 0 }}> 
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '중개보수및실비의금액과산출내역-계' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-계')?.values}
                                name="mb_phone"
                            />  
                        </td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >지급시기</td>
                        <td colSpan={14} style={{ borderRightWidth: 0 }}> 
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '중개보수및실비의금액과산출내역-지급시기' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '중개보수및실비의금액과산출내역-지급시기')?.values}
                                name="mb_phone"
                            /> 
                        </td>
                    </tr>                                                   
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} >
                            <p style={{ fontSize: 12 }}>「공인중개사법」 제25조제3항 및 제30조제5항에 따라 거래당사자는 개업공인중개사로부터 위 중개대상물에 관 한 확인ᆞ설명 및 손해배상책임의 보장에 관한 설명을 듣고, 같은 법 시행령 제21조제3항에 따른 본 확인ᆞ설 명서와 같은 법 시행령 제24조제2항에 따른 손해배상책임 보장 증명서류(사본 또는 전자문서)를 수령합니다.</p>
                            <div style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5,
                                marginTop: 8
                            }}>
                                <Select 
                                    divwidth={{   width: 100 }}
                                    setValues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '수령일년' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '수령일년')?.values}
                                    selectData={yearDatas}
                                />년
                                <Select 
                                    divwidth={{  width: 60 }}
                                    setValues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '수령일월' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '수령일월')?.values}
                                    selectData={monthDatas}
                                />월
                                <Select 
                                    divwidth={{  width: 60 }}
                                    setValues={(e) => {
                                        setinputArr(inputArr?.map(item => item?.keys === '수령일일' ? {...item, values: e} : item));
                                    }}
                                    values={inputArr?.find(item => item?.keys === '수령일일')?.values}
                                    selectData={dayDatas}
                                />일                                    
                            </div>
                        </td>
                    </tr>
                    {inputArr?.find(item => item?.keys === '매도인')?.values?.map((x, i) => {
                        let indexNumber = i;
                        if(i > 0) return;         
                        return (
                        <>
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>매도인 (임대인)</td>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >주소</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매도인', '매도인주소', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '매도인주소')?.values}
                                                                        
                                    name="mb_phone"
                                /> 
                                {x?.subflag &&
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('대리인', '대리인주소', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '대리인주소')?.values}
                                                                        
                                    name="mb_phone"
                                /> }
                            </td>
                            <td colSpan={3} className='alignc' >성명</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                (서명 또는 날인)
                                {x?.subflag &&
                                <><br /><br />(서명 또는 날인)</>
                                }
                            </td>
                        </tr>       
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >생년월일</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매도인', '매도인주민번호', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '매도인주민번호')?.values}

                                    name="mb_phone"
                                /> 
                                {x?.subflag &&
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('대리인', '대리인주민번호', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '대리인주민번호')?.values}
                                                                        
                                    name="mb_phone"
                                /> }                                
                            </td>
                            <td colSpan={3} className='alignc' >전화번호</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매도인', '매도인전화', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '매도인전화')?.values}

                                    name="mb_phone"
                                /> 
                                {x?.subflag &&
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('대리인', '대리인전화', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '대리인전화')?.values}
                                                                        
                                    name="mb_phone"
                                /> }   
                            </td>
                        </tr>                                  
                        </>
                        );
                    })}                                            


                    {inputArr?.find(item => item?.keys === '매수인')?.values?.map((x, i) => {
                        let indexNumber = i;                   
                        if(i > 0) return;                             
                        return (
                        <>
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={2}>매수인 (임차인)</td>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >주소</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매수인', '매수인주소', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '매수인주소')?.values}
                                                                        
                                    name="mb_phone"
                                /> 
                                {x?.subflag &&
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매수인', '대리인주소', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '대리인주소')?.values}
                                                                        
                                    name="mb_phone"
                                /> }   
                            </td>
                            <td colSpan={3} className='alignc' >성명</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                (서명 또는 날인)
                                {x?.subflag &&
                                <><br /><br />(서명 또는 날인)</> }   
                            </td>
                        </tr>       
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >생년월일</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매수인', '매수인주민번호', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '매수인주민번호')?.values}

                                    name="mb_phone"
                                /> 
                                {x?.subflag &&
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매수인', '대리인주민번호', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '대리인주민번호')?.values}
                                                                        
                                    name="mb_phone"
                                /> } 
                            </td>
                            <td colSpan={3} className='alignc' >전화번호</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매수인', '매수인전화', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '매수인전화')?.values}

                                    name="mb_phone"
                                /> 
                                {x?.subflag &&
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('매수인', '대리인전화', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '대리인전화')?.values}
                                                                        
                                    name="mb_phone"
                                /> } 
                            </td>
                        </tr>                                  
                        </>
                        );
                    })}         
                    
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>개업 공인중개사</td>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >등록번호</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개중등록번호1' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개중등록번호1')?.values}
                                name="mb_phone"
                            /> 
                        </td>
                        <td colSpan={3} className='alignc' >성명 (대표자)</td>
                        <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>(서명 및 날인)</td>
                    </tr>                                                   
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >사무소 명칭</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개중사무소명칭1' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개중사무소명칭1')?.values}
                                name="mb_phone"
                            /> 
                        </td>
                        <td colSpan={3} className='alignc' >소속 공인중개사</td>
                        <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개중소속공인중개사1' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개중소속공인중개사1')?.values}
                                name="mb_phone"
                            /> 
                        </td>
                    </tr>  
                    <tr>
                        <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >사무소 소재지</td>
                        <td colSpan={11} style={{ borderRightWidth: 0 }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개중사무소소재지1' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개중사무소소재지1')?.values}
                                name="mb_phone"
                            /> 
                        </td>
                        <td colSpan={3} className='alignc' >전화번호</td>
                        <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                            <Input 
                                className={`inputs`}
                                placeholder=""
                                setValue={(e) => {
                                    setinputArr(inputArr?.map(item => item?.keys === '개중전화번호1' ? {...item, values: e} : item));
                                }}
                                value={inputArr?.find(item => item?.keys === '개중전화번호1')?.values}
                                name="mb_phone"
                            /> 
                        </td>
                    </tr>  

                    {inputArr?.find(item => item?.keys === '공동중개')?.values?.map((x, i) => {
                        let indexNumber = i;         
                        if(i > 0) return;                                       
                        return (
                        <>
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} rowSpan={3}>개업 공인중개사</td>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >등록번호</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('공동중개', '공동중개등록번호', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '공동중개등록번호')?.values}
                                    name="mb_phone"
                                /> 
                            </td>
                            <td colSpan={3} className='alignc' >성명 (대표자)</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>(서명 및 날인)</td>
                        </tr>                                                   
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >사무소 명칭</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('공동중개', '공동중개사무소명칭', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '공동중개사무소명칭')?.values}
                                    name="mb_phone"
                                /> 
                            </td>
                            <td colSpan={3} className='alignc' >소속 공인중개사</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('공동중개', '공동중개소속공인중개사', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '공동중개소속공인중개사')?.values}
                                    name="mb_phone"
                                /> 
                            </td>
                        </tr>  
                        <tr>
                            <td colSpan={3} className='alignc' style={{ borderLeftWidth: 0 }} >사무소 소재지</td>
                            <td colSpan={11} style={{ borderRightWidth: 0 }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('공동중개', '공동중개사무소소재지', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '공동중개사무소소재지')?.values}
                                    name="mb_phone"
                                /> 
                            </td>
                            <td colSpan={3} className='alignc' >전화번호</td>
                            <td colSpan={10} style={{ borderRightWidth: 0, textAlign: 'right' }}>
                                <Input 
                                    className={`inputs`}
                                    placeholder=""
                                    setValue={(e) => {
                                        datavaluesFunc('공동중개', '공동중개전화번호', indexNumber, e);
                                    }}
                                    value={x?.values?.find(item => item?.keys === '공동중개전화번호')?.values}
                                    name="mb_phone"
                                /> 
                            </td>
                        </tr>                                   
                        </>
                        );
                    })}      

                    
                </table>
            </div>

            <div 
                className='fontsize12' style={{ width: '100%' }}
            >
                <table className='contractTable lrbordernone'>
                    <tr>
                        <th colSpan={30} className='alignc' style={{ borderLeftWidth: 0, borderRightWidth: 0 }} >작성방법(주거용 건축물)</th>
                    </tr>
                    <tr>
                        <td colSpan={30} style={{ borderLeftWidth: 0, borderRightWidth: 0 }} className='contractmoreText2'>
                            <div>
                                <div className='bolds'>&lt;작성일반&gt;</div>
                                <div>
                                    <p>1.</p>
                                    <p>
                                        "[ ]"있는 항목은 해당하는 "[ ]"안에 √로 표시합니다.
                                    </p>
                                </div>
                                <div>
                                    <p>2.</p>
                                    <p>
                                    세부항목 작성 시 해당 내용을 작성란에 모두 작성할 수 없는 경우에는 별지로 작성하여 첨부하고, 해당란에는 "별지 참고"라고 적습니다.
                                    </p>
                                </div>
                                <div className='bolds margint12'>&lt;세부항목&gt;</div>

                                <div>
                                    <p>1.</p>
                                    <p>「확인ᆞ설명자료」 항목의 "확인ᆞ설명 근거자료 등"에는 개업공인중개사가 확인·설명 과정에서 제시한 자료를 적으며, "대상물건의 상태에 관한 자료요구 사항"에는 매도(임대)의뢰인에게 요구한 사항 및 그 관련 자료의 제출 여부와 ⑩ 실제 권리관계 또는 공시되지 않은 물건의 권리사항부터 ⑬ 환경조건까지의 항목을 확인하기 위한 자료의 요구 및 그 불응 여부를 적습니다.</p>
                                </div>
                                <div>
                                    <p>2.</p>
                                    <p>① 대상물건의 표시부터 ⑨ 취득 시 부담할 조세의 종류 및 세율까지는 개업공인중개사가 확인한 사항을 적어야 합니다.</p>
                                </div>
                                <div>
                                    <p>3.</p>
                                    <p>① 대상물건의 표시는 토지대장 및 건축물대장 등을 확인하여 적고, 건축물의 방향은 주택의 경우 거실이나 안방 등 주실(主室)의 방향을, 그 밖의 건축물은 주된 출입구의 방향을 기준으로 남향, 북향 등 방향을 적고 방향의 기준 이 불분명한 경우 기준(예: 남동향 – 거실 앞 발코니 기준)을 표시하여 적습니다.</p>
                                </div>
                                <div>
                                    <p>4.</p>
                                    <p>② 권리관계의 "등기부 기재사항"은 등기사항증명서를 확인하여 적습니다.</p>
                                </div>
                                <div >
                                    <p></p>
                                    <div>
                                        <div className='contractmoreText2' style={{ padding: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>가.</p>
                                                <p className='fontsize12'>대상물건에 신탁등기가 되어 있는 경우에는 수탁자 및 신탁물건(신탁원부 번호)임을 적고, 신탁원부 약정사항 에 명시된 대상물건에 대한 임대차계약의 요건(수탁자 및 수익자의 동의 또는 승낙, 임대차계약 체결의 당사 자, 그 밖의 요건 등)을 확인하여 그 요건에 따라 유효한 임대차계약을 체결할 수 있음을 설명(신탁원부 교부 또는 ⑩ 실제 권리관계 또는 공시되지 않은 물건의 권리사항에 주요 내용을 작성)해야 합니다.
                                                </p>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>나.</p>
                                                <p className='fontsize12'>대상물건에 공동담보가 설정되어 있는 경우에는 공동담보 목록 등을 확인하여 공동담보의 채권최고액 등 해당 중개물건의 권리관계를 명확히 적고 설명해야 합니다.</p>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>※</p>
                                                <p className='fontsize12'>예를 들어, 다세대주택 건물 전체에 설정된 근저당권 현황을 확인ᆞ제시하지 않으면서, 계약대상 물건이 포함된 일부 호실의 공동담보 채권최고액이 마치 건물 전체에 설정된 근저당권의 채권최고액인 것처럼 중개의뢰인을 속이는 경 우에는 「공인중개사법」 위반으로 형사처벌 대상이 될 수 있습니다.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                
                                <div>
                                    <p>5.</p>
                                    <p>③ 토지이용계획, 공법상 이용제한 및 거래규제에 관한 사항(토지)의 "건폐율 상한 및 용적률 상한"은 시ᆞ군의 조례에 따라 적고, "도시·군계획시설", "지구단위계획구역, 그 밖의 도시ᆞ군관리계획"은 개업공인중개사가 확인하여 적으 며, "그 밖의 이용제한 및 거래규제사항"은 토지이용계획확인서의 내용을 확인하고, 공부에서 확인할 수 없는 사항은 부동산종합공부시스템 등에서 확인하여 적습니다(임대차의 경우에는 생략할 수 있습니다).</p>
                                </div>


                                <div>
                                    <p>6.</p>
                                    <p>④ 임대차 확인사항은 다음 각 목의 구분에 따라 적습니다.</p>
                                </div>
                                <div >
                                    <p></p>
                                    <div>
                                        <div className='contractmoreText2' style={{ padding: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>가.</p>
                                                <p className='fontsize12'>「주택임대차보호법」 제3조의7에 따라 임대인이 확정일자 부여일, 차임 및 보증금 등 정보(확정일자 부여 현황 정보) 및 국세 및 지방세 납세증명서(국세 및 지방세 체납 정보)의 제출 또는 열람 동의로 갈음했는지 구분하여 표시하고, 「공인중개사법」 제25조의3에 따른 임차인의 권리에 관한 설명 여부를 표시합니다.</p>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>나.</p>
                                                <p className='fontsize12'>임대인이 제출한 전입세대 확인서류가 있는 경우에는 확인에 √로 표시를 한 후 설명하고, 없는 경우에는 미확인에 √로 표시한 후 「주민등록법」 제29조의2에 따른 전입세대확인서의 열람ᆞ교부 방법에 대해 설명합니다(임대인이 거주하는 경우이거나 확정일자 부여현황을 통해 선순위의 모든 세대가 확인되는 경우 등에는‘해당 없음’에 √로 표시합니다).</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div >
                                    <p></p>
                                    <div>
                                        <div className='contractmoreText2' style={{ padding: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>다.</p>
                                                <p className='fontsize12'>최우선변제금은 「주택임대차보호법 시행령」 제10조(보증금 중 일정액의 범위 등) 및 제11조(우선변제를 받을 임차인의 범위)를 확인하여 각각 적되, 근저당권 등 선순위 담보물권이 설정되어 있는 경우 선순위 담보물권 설정 당시의 소액임차인범위 및 최우선변제금액을 기준으로 적어야 합니다.</p>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>라.</p>
                                                <p className='fontsize12'>"민간임대 등록여부"는 대상물건이 「민간임대주택에 관한 특별법」에 따라 등록된 민간임대주택인지 여부를 같은 법 제60조에 따른 임대주택정보체계에 접속하여 확인하거나 임대인에게 확인하여 "[ ]"안에 √로 표시하고, 민간임대 주택인 경우 같은 법에 따른 권리ᆞ의무사항을 임대인 및 임차인에게 설명해야 합니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ border: '2px solid #000', padding: 3}}>
                                    <p>*</p>
                                    <div>
                                        <p className='fontsize12'>민간임대주택은 「민간임대주택에 관한 특별법」 제5조에 따른 임대사업자가 등록한 주택으로서, 임대인과 임차인 간 임대차계약(재 계약 포함) 시에는 다음의 사항이 적용됩니다.</p>
                                        <div className='contractmoreText2' style={{ padding: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>-</p>
                                                <p className='fontsize12'>민간임대주택에 관한 특별법」 제44조에 따라 임대의무기간 중 임대료 증액청구는 5퍼센트의 범위에서 주거비 물가지수, 인 근 지역의 임대료 변동률 등을 고려하여 같은 법 시행령으로 정하는 증액비율을 초과하여 청구할 수 없으며, 임대차계약 또는 임대료 증액이 있은 후 1년 이내에는 그 임대료를 증액할 수 없습니다.</p>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>-</p>
                                                <p className='fontsize12'>「민간임대주택에 관한 특별법」 제45조에 따라 임대사업자는 임차인이 의무를 위반하거나 임대차를 계속하기 어려운 경우 등에 해당하지 않으면 임대의무기간 동안 임차인과의 계약을 해제ᆞ해지하거나 재계약을 거절할 수 없습니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div >
                                    <p></p>
                                    <div>
                                        <div className='contractmoreText2' style={{ padding: 0 }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>마.</p>
                                                <p className='fontsize12'>"계약갱신요구권 행사여부"는 대상물건이 「주택임대차보호법」의 적용을 받는 주택으로서 임차인이 있는 경우 매도인(임대인)으로부터 계약갱신요구권 행사 여부에 관한 사항을 확인할 수 있는 서류를 받으면 "확인"에 √ 로 표시하여 해당 서류를 첨부하고, 서류를 받지 못한 경우 "미확인"에 √로 표시하며, 임차인이 없는 경우에는 "해 당 없음"에 √로 표시합니다. 이 경우 개업공인중개사는 「주택임대차보호법」에 따른 임대인과 임차인의 권리 ᆞ의무사항을 매수인에게 설명해야 합니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <p>7.</p>
                                    <p>⑥ 관리비는 직전 1년간 월평균 관리비 등을 기초로 산출한 총 금액을 적되, 관리비에 포함되는 비목들에 대해서는 해당하는 곳에 √로 표시하며, 그 밖의 비목에 대해서는 √로 표시한 후 비목 내역을 적습니다. 관리비 부과방식은 해당하는 곳에 √로 표시하고, 그 밖의 부과방식을 선택한 경우에는 그 부과방식에 대해서 작성해야 합니다. 이 경우 세대별 사용량을 계량하여 부과하는 전기료, 수도료 등 비목은 실제 사용량에 따라 금액이 달라질 수 있고, 이에 따라 총 관리비가 변동될 수 있음을 설명해야 합니다.
                                    </p>
                                </div>
                                <div>
                                    <p>8.</p>
                                    <p>⑦ 비선호시설(1km이내)의 "종류 및 위치"는 대상물건으로부터 1km 이내에 사회통념상 기피 시설인 화장장ᆞ봉안당 ᆞ공동묘지ᆞ쓰레기처리장ᆞ쓰레기소각장ᆞ분뇨처리장ᆞ하수종말처리장 등의 시설이 있는 경우, 그 시설의 종류 및 위치를 적습니다.</p>
                                </div>
                                <div>
                                    <p>9.</p>
                                    <p>⑧ 거래예정금액 등의 "거래예정금액"은 중개가 완성되기 전 거래예정금액을, "개별공시지가(m²당)" 및 "건물(주택) 공시가격"은 중개가 완성되기 전 공시된 공시지가 또는 공시가격을 적습니다[임대차의 경우에는 "개별공시지가 (m²당)" 및 "건물(주택)공시가격"을 생략할 수 있습니다].</p>
                                </div>                                
                                <div>
                                    <p>10.</p>
                                    <p>⑨ 취득 시 부담할 조세의 종류 및 세율은 중개가 완성되기 전 「지방세법」의 내용을 확인하여 적습니다(임대 차의 경우에는 제외합니다).</p>
                                </div>             
                                <div>
                                    <p>11.</p>
                                    <p>⑩ 실제 권리관계 또는 공시되지 않은 물건의 권리 사항은 매도(임대)의뢰인이 고지한 사항(법정지상권, 유치권, 「주택임대차보호법」에 따른 임대차, 토지에 부착된 조각물 및 정원수, 계약 전 소유권 변동 여부, 도로의 점용허 가 여부 및 권리ᆞ의무 승계 대상 여부 등)을 적습니다. 「건축법 시행령」 별표 ① 제2호에 따른 공동주택(기숙사는 제외합니다) 중 분양을 목적으로 건축되었으나 분양되지 않아 보존등기만 마쳐진 상태인 공동주택에 대해 임대차 계약을 알선하는 경우에는 이를 임차인에게 설명해야 합니다.</p>
                                </div>
                                <div >
                                    <p></p>
                                    <div>
                                        <div className='contractmoreText2' style={{ padding: 0, paddingLeft: 10  }}>
                                            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', padding: 0 }}>
                                                <p className='fontsize12'>※</p>
                                                <p className='fontsize12'>임대차계약의 경우 현재 존속 중인 임대차의 임대보증금, 월 단위의 차임액, 계약기간 및 임대차 계약의 장기수 선충당금의 처리 등을 확인하여 적습니다. 그 밖에 경매 및 공매 등의 특이사항이 있는 경우 이를 확인하여 적 습니다.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>       
                                <div>
                                    <p>12.</p>
                                    <p>⑪ 내부ᆞ외부 시설물의 상태(건축물), ⑫ 벽면ᆞ바닥면 및 도배 상태와 ⑬ 환경조건은 중개대상물에 대해 개 업공인중개사가 매도(임대)의뢰인에게 자료를 요구하여 확인한 사항을 적고, ⑪ 내부ᆞ외부 시설물의 상태(건 축물)의 "그 밖의 시설물"은 가정자동화 시설(Home Automation 등 IT 관련 시설)의 설치 여부를 적습니다.</p>
                                </div>
                                <div>
                                    <p>13.</p>
                                    <p>⑮ 중개보수 및 실비는 개업공인중개사와 중개의뢰인이 협의하여 결정한 금액을 적되 "중개보수"는 거래예정금액을 기준 으로 계산하고, "산출내역(중개보수)"은 "거래예정금액(임대차의 경우에는 임대보증금 + 월 단위의 차임액 × 100) × 중개보수 요율"과 같이 적습니다. 다만, 임대차로서 거래예정금액이 5천만원 미만인 경우에는 "임대 보증금 + 월 단위의 차임액 × 70"을 거래예정금액으로 합니다.</p>
                                </div>
                                <div>
                                    <p>14.</p>
                                    <p>공동중개 시 참여한 개업공인중개사(소속공인중개사를 포함합니다)는 모두 서명ᆞ날인해야 하며, 2명을 넘는 경우에는 별지로 작성하여 첨부합니다.</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>  

            <div style={{
                width: '100%', textAlign: 'center', fontSize: 20, fontWeight: 700
            }}>
                {memberinfos?.compony?.title}
            </div>  

            {errmsg &&
            <div className='input_error ' style={{ width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                {errmsg}
            </div>}
            
            <div 
                style={{
                    width: '100%', margin: 'auto', marginBottom: 20, gap: 20, 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', 

                }}
            >
                <div 
                    style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
                        width: '40%'
                    }}
                >
                    <div style={{ width: '50%' }}>
                        <Button
                            buttonTxt={'이전'}
                            disabled={true} 
                            onPress={() => { 
                                scrolTopFunc();
                                setviewpages(0);
                            }}
                        />                                       
                    </div>
                    <div style={{ width: '50%'}}>
                        <Button
                            buttonTxt={'저장'}
                            styles={{ 
                            }} 
                            onPress={() => { 
                                let Arr = [{
                                    inputs: inputArr,
                                    etcText1: etcText1,
                                    etcText2: etcText2,
                                    etcText3: etcText3,
                                    etcText4: etcText4,
                                    etcText5: etcText5,
                                    etcText6: etcText6,
                                    etcText7: etcText7,
                                    etcText8: etcText8,
                                    etcText9: etcText9,
                                    etcText10: etcText10,
                                    etcText11: etcText11,
                                    etcText12: etcText12,
                                    etcText13: etcText13,
                                    etcText14: etcText14,
                                    etcText15: etcText15,
                                    etcText16: etcText16,
                                    etcText17: etcText17,
                                    etcText18: etcText18,
                                    etcText19: etcText19,
                                }];
                                // console.log(Arr);
                                // return;
                                // for(let i = 0; i < inputArr?.length; i++){
                                //     if(inputArr[i]?.requireCkr === true && inputArr[i]?.values === ''){
                                //         seterrmsg(inputArr[i]?.errmsg);
                                //         return;
                                //     }
                                // }
                                contractWirteSubmit(row?.idx ? row?.idx : null, Arr);
                            }}
                        />     
                    </div>                       
                </div>
            </div>   
        </div>
    )    
}